export default __webpack_public_path__ + "static/BonusReparation.2-bd437511fb7b2544084fe63c8285d339.jpg";